module.exports = __webpack_public_path__ + "img/checklist-pana.aa6bc0fd.svg";